import { render } from "./InfoUser.vue?vue&type=template&id=074a653a&scoped=true&ts=true"
import script from "./InfoUser.vue?vue&type=script&lang=ts"
export * from "./InfoUser.vue?vue&type=script&lang=ts"

import "./InfoUser.vue?vue&type=style&index=0&id=074a653a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074a653a"]])

export default __exports__